// services/api.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Get token dynamically (e.g., from localStorage)
const getToken = () => localStorage.getItem("token");

// Create Axios instance with interceptor for token
const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      // Attach token to the Authorization header if available
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request error (optional)
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors including rate limits
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle rate limit errors (429)
    if (error.response?.status === 429) {
      const retryAfter = error.response.headers["retry-after"] || 900;
      const message =
        error.response.data?.error?.message || "Too many requests";
      const endpoint = error.config?.url || "";

      // Determine rate limit type based on endpoint
      let rateLimitType = "api";
      if (endpoint.includes("/login")) rateLimitType = "login";
      else if (endpoint.includes("/register")) rateLimitType = "registration";
      else if (
        endpoint.includes("/forgot-password") ||
        endpoint.includes("/reset-password")
      )
        rateLimitType = "password-reset";
      else if (
        endpoint.includes("/bulk-import") ||
        endpoint.includes("/send-messages")
      )
        rateLimitType = "bulk-operation";
      else if (endpoint.includes("/messages")) rateLimitType = "message";

      // Store rate limit info for UI components
      const rateLimitInfo = {
        type: rateLimitType,
        message,
        retryAfter: parseInt(retryAfter),
        timestamp: Date.now(),
        endpoint,
      };

      localStorage.setItem(
        `rateLimit_${rateLimitType}`,
        JSON.stringify(rateLimitInfo)
      );

      // Add rate limit info to error object for component use
      error.rateLimitInfo = rateLimitInfo;
    }

    // Handle authentication errors (401)
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      // Don't redirect if already on login page
      if (!currentPath.includes("/login")) {
        localStorage.removeItem("token");
        localStorage.removeItem("userRole");
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

// Export the instance to use everywhere
export default api;
